import isEmpty from 'lodash/isEmpty';

export const validateReviewsSnippet = (reviews) => !!(reviews && !isEmpty(reviews.reviews_snippet));
